import type { components } from '../../../api-types/storeApiTypes'

export type SeoUrl = components['schemas']['SeoUrl']

const toPath = (seoUrl?: Partial<SeoUrl> | null) => {
  if (!seoUrl) return ''
  return seoUrl.seoPathInfo ? `/${seoUrl.seoPathInfo}` : seoUrl.pathInfo || ''
}

export const pickCanonicalSeoUrl = (
  seoUrls: SeoUrl[] | undefined,
  opts?: { languageId?: string; salesChannelId?: string },
): string | '' => {
  if (!seoUrls || !seoUrls.length) return ''

  const { languageId, salesChannelId } = opts || {}

  // 1) exact match: canonical + same language (+ optional sales channel)
  if (languageId || salesChannelId) {
    const exact = seoUrls.find(
      (s) =>
        s.isCanonical &&
        (!languageId || s.languageId === languageId) &&
        (!salesChannelId || s.salesChannelId === salesChannelId),
    )
    if (exact) return toPath(exact)
  }

  // 2) any canonical
  const canonical = seoUrls.find((s) => s.isCanonical)
  if (canonical) return toPath(canonical)

  // 3) first with seoPathInfo
  const anySeo = seoUrls.find((s) => s.seoPathInfo)
  if (anySeo) return toPath(anySeo)

  // 4) technical path
  return toPath(seoUrls[0])
}
